import { computed, defineComponent, onMounted, ref, useCssModule, useRouter } from '@nuxtjs/composition-api';
import { enableRouterForDOMLinks, parseLinksInString } from '~/utils';
export default defineComponent({
    name: 'BoxList',
    props: {
        box: {
            required: true,
            type: Object,
        },
        schemaDisabled: {
            default: false,
            type: Boolean,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Router.
         */
        const router = useRouter();
        const rootEl = ref();
        const isRelatedList = computed(() => {
            const { data, type } = props.box;
            return type === 'related-list' || data?.items?.every((item) => item.startsWith('<a') && item.endsWith('</a>'));
        });
        const rootTag = computed(() => {
            const { style } = props.box.data || {};
            return style && style === 'ordered' ? 'ol' : 'ul';
        });
        const items = computed(() => {
            return props.box.data?.items?.map((item) => {
                if (typeof item === 'string') {
                    return {
                        attrs: {},
                        component: 'span',
                        text: parseLinksInString(item),
                    };
                }
                const { text = '', url = '' } = item;
                const path = parseLinksInString(url);
                if (path && path.match(/(https?:)?\/\//g)) {
                    return {
                        attrs: {
                            href: path,
                            rel: 'noopener nofollow',
                            target: '_blank',
                        },
                        component: 'a',
                        text,
                    };
                }
                return {
                    attrs: {
                        to: '/' + path,
                    },
                    component: 'NLink',
                    text,
                };
            });
        });
        onMounted(() => {
            if (!rootEl.value) {
                return;
            }
            enableRouterForDOMLinks({
                target: rootEl.value,
                router,
            });
        });
        return {
            css,
            isRelatedList,
            items,
            rootEl,
            rootTag,
        };
    },
});
